import React from 'react';
import { useLayoutContext } from '../Contexts/LayoutContext';
import { useLoginContext } from '../Contexts/LoginContext';
import FidelityRegulation from '../Components/Layout/FidelityRegulation';
import FidelityBoxBalance from './FidelityBoxBalance';
import FidelityHeader from './FidelityHeader';
import FidelityExtract from './FidelityExtract';

interface FidelityDashboardProps {
    fidelityExpireInfo: {
        daysToExpire: number;
        expiring: number;
        expired: number;
    } | null;
}

const FidelityDashboard = ({ fidelityExpireInfo }: FidelityDashboardProps) => {
    const { company } = useLayoutContext();
    const { user } = useLoginContext();

    if (!user || !company?.fidelity) return null;

    const { expiring, expired } = fidelityExpireInfo || {};

    const availablePoints = Number(user.all_points ?? (typeof user.fidelity_points === 'number' ? user.fidelity_points : 0));
    const currencyName = company.fidelity.currency_name || "Pontos";

    return (
        <div className="w-full flex flex-col items-center gap-8 py-4">

            {/* Header / Congratulations */}
            <FidelityHeader
                title="Programa de Fidelidade"
                subtitle="Parabéns! Você está participando do nosso programa de fidelidade, utilize seus pontos para ganhar descontos!"
            />

            {/* Balance Card (Dynamic Branding) */}
            <FidelityBoxBalance 
                currencyName={currencyName} 
                availablePoints={availablePoints} 
                expiring={expiring || 0} 
                expired={expired || 0} 
                company={company} 
                availableBalance={availablePoints * company.fidelity.point_value} 
            />

            {/* Extract Section */}
            <FidelityExtract />

            {/* Regulation Section */}
            <FidelityRegulation company={company} />
        </div>
    );
};

export default FidelityDashboard;
